var React = require('react');

function House (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0.379261 10.4659L12.7179 0.239789C13.1043 -0.0804311 13.664 -0.0798712 14.0497 0.241122L26.3382 10.4672C27.0878 11.091 26.6467 12.3107 25.6715 12.3107H23.1958C23.254 12.7463 23.2841 13.1909 23.2841 13.6425C23.2841 19.143 18.825 23.6021 13.3244 23.6021C7.82389 23.6021 3.36481 19.143 3.36481 13.6425C3.36481 13.1909 3.39487 12.7463 3.45308 12.3107H1.04436C0.0681209 12.3107 -0.372385 11.0889 0.379261 10.4659Z","fill":"#3A9A9F","key":0}),React.createElement("path",{"d":"M13.5 21C17.0899 21 20 18.0899 20 14.5H7C7 18.0899 9.91015 21 13.5 21Z","fill":"#FFEC89","key":1}),React.createElement("path",{"d":"M21.7737 0.926749L17.0979 6.40136L20.2263 9.07326L24.9021 3.59865L21.7737 0.926749Z","fill":"#3A9A9F","key":2})]);
}

House.defaultProps = {"width":"27","height":"24","viewBox":"0 0 27 24","fill":"none"};

module.exports = House;

House.default = House;
